export default "/images/crypto_environments/solana_icon__one.png";